package io.horion.cv.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.HTMLDivElement
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.Node
import org.w3c.dom.events.Event

@Composable
fun RichTextArea(
    value: String,
    onValueChange: (String) -> Unit,
    editorRef: ((HTMLDivElement?) -> Unit)? = null,
    onSelectionChange: (() -> Unit)? = null,
) {

    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Div(
        attrs = {
            attr("contenteditable", "true")
            attr("role", "textbox")
            attr("aria-multiline", "true")
            attr("data-placeholder", "Commencez à rédiger ici...")

            style {
                property("display", "block")
                property("width", "100%")
                property("max-width", "100%")
                property("min-width", "0")
                property("min-height", "140px")
                property("box-sizing", "border-box")

                property("padding", "0")
                property("margin", "0")
                property("outline", "none")

                property(
                    "background-color",
                    if (isDark) Colors.input else Colors.LightGray
                )

                property("font-family", INTER)
                property("font-size", "14px")
                property("line-height", "1.6")

                property("white-space", "pre-wrap")
                property("overflow-wrap", "anywhere")
                property("word-break", "break-word")
                property("overflow-x", "hidden")
                property("overflow-y", "auto")
            }

            ref { element ->
                editorRef?.invoke(element)

                if (element.innerHTML != value) {
                    element.innerHTML = value
                }

                val selectionHandler: (Event) -> Unit = {
                    val sel = window.asDynamic().getSelection()

                    if (sel != null && (sel.rangeCount as Int) > 0) {
                        val range = sel.getRangeAt(0)
                        val ancestor = range.commonAncestorContainer

                        if (element.contains(ancestor as? Node)) {
                            onSelectionChange?.invoke()
                        }
                    }
                }

                document.addEventListener("selectionchange", selectionHandler)

                onDispose {
                    editorRef?.invoke(null)
                    document.removeEventListener("selectionchange", selectionHandler)
                }
            }

            addEventListener("input") { event ->
                val html = (event.target as? HTMLDivElement)?.innerHTML ?: ""
                onValueChange(html)
            }

            addEventListener("keyup") {
                onSelectionChange?.invoke()
            }

            addEventListener("mouseup") {
                onSelectionChange?.invoke()
            }
        }
    )
}